import { Fragment, ReactElement } from 'react';
import PersonCivilUnionNonResidentNotificationCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-civil-union-non-resident/edit-person';
import { IdAmbito } from 'shell/constants/id-ambito';

const PersonCivilUnionNonResidentNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <PersonCivilUnionNonResidentNotificationCivilStatusShared scope={IdAmbito.Mutazioni} />
    </Fragment>
  );
};

PersonCivilUnionNonResidentNotificationCivilStatusPage.displayName =
  'Research CivilUnion Non Resident Notifications Page component';

export default PersonCivilUnionNonResidentNotificationCivilStatusPage;
